import { safeLocalStorage } from '@/utils/safeLocalStorage';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { AlertProps } from '../components/Alert';
import { UseBreadcrumbsProps } from '../components/Breadcrumbs';

export const currentAccountIdAtom = atomWithStorage<string>(
  'currentAccountId',
  safeLocalStorage.getItem('currentAccountId') || '',
);
export const currentUserAtom = atomWithStorage(
  'currentUser',
  safeLocalStorage.getItem('currentUser') || {},
);
export const currentAccountUsersAtom = atomWithStorage<any>(
  'currentAccountUsers',
  safeLocalStorage.getItem('currentAccountUsers') || [],
);
export const currentAccountUserFlagsAtom = atomWithStorage<
  Array<{ accountUserId: string; flags: string[] }>
>(
  'currentAccountUserFlags',
  safeLocalStorage.getItem('currentAccountUserFlags') || [],
);
export const currentAccountAtom = atom(get => {
  const currentAccountId = get(currentAccountIdAtom);
  const currentAccountUsers = get(currentAccountUsersAtom);
  const currentAccountUserFlags = get(currentAccountUserFlagsAtom);

  const currentAccountUser = currentAccountUsers.find(
    accountUser => accountUser.accountId === currentAccountId,
  );

  const flagsForAccount =
    currentAccountUserFlags.find(f => f.accountUserId === currentAccountUser?.id)?.flags || [];

  return {
    ...currentAccountUser?.account,
    role: currentAccountUser?.role,
    roles: currentAccountUser?.roles || [],
    flags: flagsForAccount,
  };
});

export const loadingAuthUserAtom = atom<boolean>(true);
export const freshdeskContextAtom = atom<any>({});
export const toastsAtom = atom<AlertProps[]>([]);
export const breadcrumbsAtom = atom<UseBreadcrumbsProps[]>([]);
